<template>
    <div class="row">
        <schedule />
        <enterprise-logo class="half-height" />
    </div>
    <parcels :parcels="props.contracts.parcelas" />
    <occurrence />
</template>
<script setup>
// import BuildingProgressCard from "./BuildingProgressCard.vue";
import Parcels from '../../FinancialCenter/components/Parcels.vue';
import Schedule from './ScheduleCard.vue';
import EnterpriseLogo from './EnterpriseLogo.vue';
import Occurrence from './Occurrence.vue';
import { useStore } from "vuex";
import { onMounted, computed } from 'vue';
import axios from 'axios'

const store = useStore();

onMounted(() => {
    updateCurrentContract();
});

const props = defineProps({
    contracts: {
        type: Object,
        required: true,
    }
});

const updateCurrentContract = async () => {
    try {
        const response = await axios.get('/contract-ws?page=0&size=10');
        store.commit('updateAllContracts', response.data.result.contratos);
        updateContract();
    } catch (error) {
        console.log(error);
    }
    //add try-catch
};

const updateContract = () => {

    let allContracts = computed(() => store.getters.getAllContract);
    let currentContract = computed(() => store.getters.getCurrentContract);
    let contratoId = (currentContract && currentContract.value && currentContract.value.contrato_id) ? currentContract.value.contrato_id : null;

    let index = -1;

    for (let i = 0; i < allContracts.value.length; i++) {
        const obj = allContracts.value[i];
        if (obj.contrato_id === contratoId) {
            index = i;
            break;
        }
    }
    store.commit('updateContract', allContracts.value[index]);
}



</script>

<style>
.half-height {
    height: 50% !important;
}
</style>